import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRealmApp } from 'RealmApp';
import { Carousel, Col, Row, Spin } from 'antd';
import useScreenSize from 'hooks/useScreenSize';
import { useTranslation } from 'react-i18next';
import s from './styles';
import Logo from '../../components/icons/Logo';
import LanguageSelector from '../SideBarTopMenuHOC/LanguageSelector';
import wallpaper from '../../assets/images/LoginBackground.png';
import onboarding1 from '../../assets/images/onboarding1.png';
import onboarding2 from '../../assets/images/onboarding2.png';
import onboarding3 from '../../assets/images/onboarding3.png';

function ConfirmAccount() {
  const { t } = useTranslation();
  const app = useRealmApp();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);

  useEffect(() => {
    if (!params.get('token') || !params.get('tokenId')) {
      navigate('/500');
    } else {
      app.emailPasswordAuth
        .confirmUser({
          token: params.get('token'),
          tokenId: params.get('tokenId'),
        })
        .then(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          navigate('/500');
        });
    }
  }, []);

  const { height } = useScreenSize();

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      <s.headerContainer>
        <a href="/">
          <Logo />
        </a>
        <LanguageSelector login />
      </s.headerContainer>

      <Row>
        <Col xs={24} md={12}>
          <s.formContainer>
            <s.form>
              <s.Title>{t('containers.ConfirmAccount.accountCreated')}</s.Title>
              <s.line />
              <s.SubTitle style={{ marginTop: '36px' }}>
                {t('containers.ConfirmAccount.accountCreatedText')}
              </s.SubTitle>
              <s.Button
                onClick={() => {
                  navigate('/login');
                }}
              >
                {' '}
                {t('containers.ConfirmAccount.login')}
              </s.Button>
            </s.form>
          </s.formContainer>
        </Col>
        <Col
          xs={24}
          md={12}
          style={{
            backgroundImage: `url(${wallpaper})`,
            minHeight: '100vh',
            height: 'auto',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <Carousel
            autoplay
            style={{
              height: height < 687 ? '687px' : '100vh',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div style={{}}>
              <s.imageContainer>
                <img
                  src={onboarding1}
                  style={{ maxWidth: '600px', width: '100%' }}
                />
              </s.imageContainer>
              <s.textContainer>
                <div
                  style={{ width: '50%', textAlign: 'center', color: 'white' }}
                >
                  <s.TitleLeft>
                    {t('containers.registrationPages.onboardingTitle')}
                  </s.TitleLeft>
                  <s.SubTitleRight>
                    {t('containers.registrationPages.onboardingMessage')}
                  </s.SubTitleRight>
                </div>
              </s.textContainer>
            </div>
            <div style={{}}>
              <s.imageContainer>
                <img
                  src={onboarding2}
                  style={{ maxWidth: '600px', width: '100%' }}
                />
              </s.imageContainer>
              <s.textContainer>
                <div
                  style={{ width: '50%', textAlign: 'center', color: 'white' }}
                >
                  <s.TitleLeft>
                    {t('containers.registrationPages.onboardingTitle2')}
                  </s.TitleLeft>
                  <s.SubTitleRight>
                    {t('containers.registrationPages.onboardingMessage2')}
                  </s.SubTitleRight>
                </div>
              </s.textContainer>
            </div>
            <div style={{}}>
              <s.imageContainer>
                <img
                  src={onboarding3}
                  style={{ maxWidth: '600px', width: '100%' }}
                />
              </s.imageContainer>
              <s.textContainer>
                <div
                  style={{ width: '50%', textAlign: 'center', color: 'white' }}
                >
                  <s.TitleLeft>
                    {t('containers.registrationPages.onboardingTitle3')}
                  </s.TitleLeft>
                  <s.SubTitleRight>
                    {t('containers.registrationPages.onboardingMessage3')}
                  </s.SubTitleRight>
                </div>
              </s.textContainer>
            </div>
          </Carousel>
        </Col>
      </Row>
    </>
  );
}

export default ConfirmAccount;
